import { render, staticRenderFns } from "./layout-extender.vue?vue&type=template&id=2a6a1b02"
import script from "./layout-extender.vue?vue&type=script&lang=js"
export * from "./layout-extender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports